/**
 * The one-tap way in: no menu, no category, no form — press it and the camera
 * opens. The add sheet appears afterwards, already holding the photo.
 *
 * Docked at the bottom of the screen rather than floating in a corner, so it's
 * where a thumb already is.
 */

import { usePhotoCapture } from "./usePhotoCapture";
import { Icon } from "./Icon";

import "./CameraButton.css";

interface CameraButtonProps {
  onCapture: (photo: string) => void;
  onError: (message: string) => void;
}

export function CameraButton({ onCapture, onError }: CameraButtonProps) {
  const { inputRef, isWorking, handleChange, open } = usePhotoCapture({
    onPhoto: onCapture,
    onError,
  });

  return (
    <div className="camera">
      <input
        ref={inputRef}
        className="sr-only"
        type="file"
        accept="image/*"
        capture="environment"
        onChange={handleChange}
      />
      <button
        className="camera__button"
        type="button"
        onClick={open}
        disabled={isWorking}
        aria-label={isWorking ? "Preparing photo" : "Add with camera"}
      >
        <Icon name="camera" className="camera__icon" />
      </button>
    </div>
  );
}
